import { STATUSES, STATUS_STYLE, testId } from "./crmShared";

export const PipelineBar = ({ counts, total, active, onPick }) => (
  <div data-testid="crm-pipeline" className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3">
    {STATUSES.map((s, i) => {
      const n = counts?.[s] || 0;
      const pct = total ? Math.round((n / total) * 100) : 0;
      return (
        <button key={s} data-testid={`pipeline-stage-${testId(s)}`} onClick={() => onPick(active === s ? "" : s)}
          style={{ animationDelay: `${i * 45}ms` }}
          className={"crm-rise text-left rounded-2xl border px-4 py-4 transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 " +
            (active === s ? "border-amber-500/60 bg-amber-500/10" : "border-gray-800 bg-card hover:border-gray-700")}>
          <span className={"inline-flex px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border " + STATUS_STYLE[s]}>{s}</span>
          <p data-testid={`pipeline-count-${testId(s)}`} className="mt-3 font-display text-3xl font-bold text-white tabular-nums">{n}</p>
          <div className="mt-2 h-1 rounded-full bg-gray-800 overflow-hidden"><div className="h-full bg-amber-400/70" style={{ width: `${pct}%` }} /></div>
          <p className="mt-1 text-[11px] text-gray-500">{pct}% of pipeline</p>
        </button>
      );
    })}
  </div>
);
